<template>
  <v-card>
    <v-card-title :style="style" class="px-2">
      <v-btn icon @click="handleBackButton()">
        <v-icon color="white">mdi-keyboard-backspace</v-icon>
      </v-btn>
      {{ title }}
    </v-card-title>
    <v-card-text class="pa-0">
      <v-row justify="end">
        <v-col cols="8" md="4" class="pt-1 pb-0">
          <v-text-field v-model="filter" class="mt-0 pt-0 pr-1" clearable hide-details :placeholder="placeholder" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="(schItem, si) in filteredItems" :key="si" cols="12" class="py-0">
          <component :is="itemComponent" :key="si" :schedule-item="schItem" class="ma-1" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style>
</style>

<script>
import scheduleItemHelper from '@/services/clientViewer/scheduleItemHelper.js';
import ScheduledItem from '@/components/Client/LineOfBusiness/Schedules/ScheduledItem.vue';
import UnscheduledItem from '@/components/Client/LineOfBusiness/Schedules/UnscheduledItem.vue';
export default {
  name: 'ScheduledItemsCard',
  components: {
    ScheduledItem,
    UnscheduledItem
  },
  props: {
    scheduledItems: {
      type: Array,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      },
      filter: ''
    };
  },
  computed: {
    title: function () {
      return this.type === 1 ? 'Scheduled Items' : 'Unscheduled Items';
    },
    itemComponent: function () {
      return this.type === 1 ? 'ScheduledItem' : 'UnscheduledItem';
    },
    placeholder: function () {
      return `Filter ${this.title}`;
    },
    filteredItems: function () {
      if ((this.filter || null) === null || this.filter === '') {
        return this.scheduledItems;
      }

      if (this.type === 1) {
        // Filter Schedule Items
        return this.scheduledItems.filter((x) => scheduleItemHelper.scheduleItemTitle(x).toLowerCase().includes(this.filter.toLowerCase()));
      } else {
        // Filter Unscheduled Items
        return this.scheduledItems.filter((x) => x.description.toLowerCase().includes(this.filter.toLowerCase()));
      }
    }
  },
  methods: {
    handleBackButton: function () {
      this.$emit('closeScheduleItemsDialog');
      this.filter = '';
    }
  }
};
</script>
